module.exports = "<div class=\"view-port main-div\">\n    <h3 class=\"module-header header-margin\">\n        <span class=\"span-margin\">Transport Analytics</span>\n    </h3>\n    <iframe class=\"embedded-content-view\" name=\"underlay-app-embed\" [src]=\"iframeUrl\"\n        frameborder=\"0\">\n    </iframe>\n\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/underlay-app/underlay-app-embed.html
// module id = zDR0
// module chunks = 0